import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaUser,
  FaHeart,
  FaShoppingBag,
  FaMapMarkerAlt,
  FaArrowRight,
} from "react-icons/fa";
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const MobileSidebarLink = () => {
  const token = localStorage.getItem("STITCHD_ID");
  const [profile, setProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const decoded = jwtDecode(token);
  const { pathname } = useLocation();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/user/${decoded._id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const userData = response.data.user;
        setProfile(userData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setLoading(false);
      }
    };

    if (token) {
      fetchUserData();
    }
  }, [token, decoded._id]);

  // Function to determine active link index based on current pathname
  const getActiveLinkIndex = (path) => {
    switch (path) {
      case "/account":
        return 0;
      case "/wishlist":
        return 1;
      case "/orders":
        return 2;
      case "/address":
        return 3;
      case "/allorders":
        return 4;
      default:
        return 5; // Default to Profile if path doesn't match
    }
  };

  const activeLinkIndex = getActiveLinkIndex(pathname);

  // List of predefined links
  const links = [
    { to: "/account", text: "My Profile", icon: FaUser },
    { to: "/wishlist", text: "My Wishlist", icon: FaHeart },
    { to: "/orders", text: "My Orders", icon: FaShoppingBag },
    { to: "/address", text: "My Addresses", icon: FaMapMarkerAlt },
  ];

  // Add admin specific link
  if (decoded.role === "ADMIN") {
    links.push({ to: "/allorders", text: "All Orders", icon: FaShoppingBag });
  }

  // Get the first initial of the full name
  const firstInitial = profile.fullName ? profile.fullName.charAt(0).toUpperCase() : "S";

  return (
    <div className="p-4">
      <div className="flex flex-col mt-16 font-twentieth-century text-2xl md:w-72 shadow-xl border rounded-2xl pb-4">
        <div className="flex flex-col md:flex-row items-center shadow-lg rounded-2xl p-3 mb-4">
          <div className="bg-gray-300 rounded-full w-16 h-16 flex items-center justify-center font-bold text-4xl text-center mb-2 mr-2 font-mono">
            {loading ? <Skeleton circle={true} height={64} width={64} /> : firstInitial}
          </div>
          <div className="text-center font-sans text-[20px] font-semibold">
            {loading ? <Skeleton width={120} /> : <p className="tracking-widest md:tracking-normal">Welcome Back!</p>}
            {loading ? <Skeleton width={180} /> : <p className="font-twentieth-century tracking-wider text-[24px]">{profile.fullName}</p>}
          </div>
        </div>
        {links.map((link, index) => (
          <Link
            key={index}
            to={link.to}
            className={`flex items-center justify-between bg-gray-100 hover:bg-red-200 text-gray-800 m-2 mx-6 p-2 rounded-[30px] border transition duration-300 ${
              activeLinkIndex === index ? "text-red-600" : ""
            }`}
          >
            <div className="flex items-center md:text-[22px]">
              {loading ? <Skeleton width={24} height={24} className="mr-4" /> : <link.icon className="mr-4" />}
              {loading ? <Skeleton width={120} /> : link.text}
            </div>
            {!loading && <FaArrowRight />}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MobileSidebarLink;
